const mEditionSectionContentInfoNodeActions = {
  mEditionSectionContentInfoNodeActions: {
    alerts: {
      updateInscripcionNodoEstado: {
        error: 'Un error ha ocurrido. Vuelve a intentarlo en un momento.',
        success: {
          notViewed: 'El contenido se marcó como no visto exitosamente.',
          viewed: 'El contenido se marcó como visto exitosamente.'
        }
      }
    },

    tooltips: {
      next: 'Siguiente',
      notViewed: 'No visto',
      previous: 'Anterior',
      viewed: 'Visto'
    }
  }
}

export default mEditionSectionContentInfoNodeActions
